var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer wrap"},[_c('p',[_vm._v("@2022 报名系统")]),_c('p',[_vm._v("版权所有：国家市场监督管理总局专业技术人才开发中心")])])
}]

export { render, staticRenderFns }